

























































































































































































/** @format */

function getBase64(file: Blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}
// 文件上传状态
enum UploadStatus {
  UPLOADING = 'uploading', // 上传中
  DONE = 'done', // 完成上传
  ERROR = 'error', // 上传出现错误
  REMOVED = 'removed' // 文件已移除
}
/** @format */
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

import moment from 'moment';
import { cloneDeep } from 'lodash';
import { trim } from '@root/utils/validators';
import Utils from '@root/utils/common';
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';
import ByTimeRule from './by-time-rule.vue';
import SplitPartRule from './split-part-rule.vue';
import SplitTimeRule from './split-time-rule.vue';
import ByTimesRule from './by-times-rule.vue';
import BillingOnTime from './billing-on-time.vue';
import RuleWrapByDataPattern from './rule-wrap-by-data-pattern.vue';
import RuleWrapByDataPTab from './rule-wrap-by-data-tab.vue';

import { TEMPORARY_PARKING_CHARGING_RULE } from '../../router-names';

import { IDictionaryInfo } from '@root/types/dictionaries';
import { addRule, getById } from '@/api/parking-lot-management';
import {
  IByTimeMainForm,
  byTimeMainFormDefault,
  IByTimeBackUpForm,
  byTimeBackUpFormDefault,
  IOnTimesForm,
  onTimesFormDefault,
  IOnSeparateForm,
  onSeparateFormDefault,
  IOnSeparateFormArr,
  onSeparateFormArrDefault,
  IOnShareTimeForm,
  onShareTimeFormDefault,
  IOnShareTimeFormArr,
  onShareTimeFormArrDefault,
  normalForm,
  IOnOnceForm
} from './type';
import { API_SERVER } from '@/common/config';
import ImageUploader from '@/components/img-upload/index.vue';
@Component({
  components: {
    ParkingLotSearch,
    ByTimeRule,
    SplitPartRule,
    SplitTimeRule,
    ByTimesRule,
    RuleWrapByDataPattern,
    RuleWrapByDataPTab,
    ImageUploader,
    BillingOnTime
  }
})
export default class FeeRuleAddEdit extends Vue {
  @Prop()
  parkId!: string;

  @Prop()
  id!: string;

  // 初始化查询时使用
  @Prop()
  billingWay!: string;

  @Prop({ type: String, default: 'add' })
  status!: string; // edit||detail||add

  @Prop({ type: Boolean, default: false })
  visible!: boolean;
  // 面包屑数据
  get breadcrumbNav() {
    return [
      {
        label: '临停计费规则',
        location: {
          name: TEMPORARY_PARKING_CHARGING_RULE
        }
      },
      {
        label: this.statusTitle
      }
    ];
  }

  get statusTitle() {
    let title = '';
    switch (this.$route.query.type) {
      case 'add':
        title = '添加';
        break;
      case 'edit':
        title = '编辑';
        break;
      case 'detail':
        title = '查看';
        break;
      default:
        break;
    }
    return `${title}临停计费规则`;
  }

  get editDisabled() {
    return this.status === 'edit';
  }
  get detailDisabled() {
    return this.status === 'detail';
  }

  initloading: boolean = false;
  private imagesListData: any[] = [];
  initImageUrls: any[] = []; //原文件列表
  // 基础提交信息
  basicForm: any = {
    feeName: '',
    parkId: '',
    billingWay: '0',
    datePattern: '0',
    ruleCode: '',
    remarks: '',
    images: []
  };
  isGrid: boolean = false;
  // ----------按时收费
  byTimeMainForm: IByTimeMainForm = byTimeMainFormDefault;
  byTimeBackUpForm: IByTimeMainForm = cloneDeep(byTimeMainFormDefault);
  // ----------分段计费
  onSeparateForm: IOnSeparateForm = onSeparateFormDefault;
  onSeparateFormArr: IOnSeparateFormArr[] = onSeparateFormArrDefault;
  onSeparateBackUpForm: IOnSeparateForm = cloneDeep(onSeparateFormDefault);
  onSeparateBackUpFormArr: IOnSeparateFormArr[] = cloneDeep(onSeparateFormArrDefault);
  // ----------分时计费
  onShareTimeForm: IOnShareTimeForm = onShareTimeFormDefault;
  onShareTimeFormArr: IOnShareTimeFormArr[] = onShareTimeFormArrDefault;
  onShareTimeBackForm: IOnShareTimeForm = cloneDeep(onShareTimeFormDefault);
  onShareTimeBackFormArr: IOnShareTimeFormArr[] = cloneDeep(onShareTimeFormArrDefault);
  // ----------按次计费
  onTimesForm: IOnTimesForm = onTimesFormDefault;
  onTimesBackUpForm: IOnTimesForm = cloneDeep(onTimesFormDefault);
  // ----------新 按时收费
  normalForm: any = normalForm;
  holidayForm: any = cloneDeep(normalForm);

  get ruleBillingWayOptions(): any[] {
    return Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries.cp_base_rule_original_billing_way);
  }
  get datePatternOptions(): any[] {
    return Utils.toLabelVal({ '0': '常规', '1': '工作日/节假日' });
  }
  @Watch('visible')
  visibleChanged(val: boolean) {
    if (val) {
      this.init();
    }
  }
  // @Watch('id')
  // idChanged(val: boolean) {
  //   console.log(1)
  //   this.init()
  // }
  @Watch('status')
  statusChange(newVal: any, oldVal: any) {
    // 前后俩次的值一致时不执行函数
    if (newVal === oldVal) {
      return;
    }
    // 查看的时候进行数据回显请求
    if (newVal === 'detail') {
      this.init();
    }
  }

  spining: boolean = false;
  // 生命周期初始化
  created() {
    this.init();
  }
  moment = moment;

  // 初始化form表单
  async init() {
    console.log('this.id', this.id);

    if (this.id) {
      // 编辑或者查询状态，需调用查询接口
      if (this.initloading) return false;
      this.initloading = true;
      try {
        const { data = {} } = await getById({
          id: this.id,
          serviceName: this.getRuleServiceName(this.billingWay)
        });
        this.basicForm = data.basicForm || {};
        const images = this.basicForm.images || [];
        if (images) {
          this.imagesListData = images.map((item: string, index: number) => {
            return {
              uid: index,
              name: item,
              status: 'done',
              url: `${API_SERVER.imgBaseUrl}${item}`,
              filePath: item
            };
          });
          this.initImageUrls = JSON.parse(JSON.stringify(images));
        }
        const billingWay = this.basicForm.billingWay;

        if (billingWay === '0') {
          const { byTimeMainForm, byTimeBackUpForm } = data;
          this.byTimeMainForm = byTimeMainForm;
          if (byTimeBackUpForm) {
            this.byTimeBackUpForm = byTimeBackUpForm;
          }
        } else if (billingWay === '1') {
          const { onSeparateForm, onSeparateFormArr, onSeparateBackUpForm, onSeparateBackUpFormArr } = data;
          this.onSeparateForm = onSeparateForm;
          // this.extracted(onSeparateFormArr);
          this.onSeparateFormArr = onSeparateFormArr;
          if (onSeparateBackUpForm && onSeparateBackUpFormArr) {
            // this.extracted(onSeparateBackUpFormArr);
            this.onSeparateBackUpForm = onSeparateBackUpForm;
            this.onSeparateBackUpFormArr = onSeparateBackUpFormArr;
          }
        } else if (billingWay === '2') {
          const { onShareTimeForm, onShareTimeFormArr, onShareTimeBackForm, onShareTimeBackFormArr } = data;
          this.onShareTimeForm = onShareTimeForm;
          this.onShareTimeFormArr = onShareTimeFormArr;
          if (onShareTimeBackForm && onShareTimeBackFormArr) {
            this.onShareTimeBackForm = onShareTimeBackForm;
            this.onShareTimeBackFormArr = onShareTimeBackFormArr;
          }
        } else if (billingWay === '3') {
          const { onTimesForm, onTimesBackUpForm } = data;
          this.onTimesForm = onTimesForm;
          if (onTimesBackUpForm) {
            this.onTimesBackUpForm = onTimesBackUpForm;
          }
        } else if (billingWay === '4' || billingWay === '5') {
          let { normalForm, holidayForm } = data;
          this.normalForm = { ...this.normalForm, ...normalForm };
          if (this.normalForm.isPremiumFenSwitch === '1' && this.normalForm.rules.length > 0) {
            for (let i = 0; i < this.normalForm.rules.length; i++) {
              this.normalForm.rules[i].startTime = moment(this.normalForm.rules[i].startTime || '00:00', 'HH:mm');
              this.normalForm.rules[i].endTime = moment(this.normalForm.rules[i].endTime || '00:00', 'HH:mm');
            }
            console.log('111', this.normalForm.rules, '2222--------->');
          }
          // 判断是展开还是收起
          this.foldtwo();
          console.log(this.normalForm, '000--------------->');
          if (holidayForm) {
            this.holidayForm = { ...this.holidayForm, ...holidayForm };
            if (this.holidayForm.isPremiumFenSwitch === '1' && this.holidayForm.rules.length > 0) {
              for (let j = 0; j < this.holidayForm.rules.length; j++) {
                console.log('222');
                this.holidayForm.rules[j].startTime = moment(this.holidayForm.rules[j].startTime || '00:00', 'HH:mm');
                this.holidayForm.rules[j].endTime = moment(this.holidayForm.rules[j].endTime || '00:00', 'HH:mm');
              }
            }
            this.foldtwohold();
          }
        } else if (billingWay === '4' || billingWay === '5') {
          let { normalForm, holidayForm } = data;
          this.normalForm = { ...this.normalForm, ...normalForm };
          if (this.normalForm.isPremiumFenSwitch === '1' && this.normalForm.rules.length > 0) {
            for (let i = 0; i < this.normalForm.rules.length; i++) {
              this.normalForm.rules[i].startTime = moment(this.normalForm.rules[i].startTime || '00:00', 'HH:mm');
              this.normalForm.rules[i].endTime = moment(this.normalForm.rules[i].endTime || '00:00', 'HH:mm');
            }
            console.log('111', this.normalForm.rules, '2222--------->');
          }
          // 判断是展开还是收起
          this.foldtwo();
          console.log(this.normalForm, '000--------------->');
          if (holidayForm) {
            this.holidayForm = { ...this.holidayForm, ...holidayForm };
            if (this.holidayForm.isPremiumFenSwitch === '1' && this.holidayForm.rules.length > 0) {
              for (let j = 0; j < this.holidayForm.rules.length; j++) {
                console.log('222');
                this.holidayForm.rules[j].startTime = moment(this.holidayForm.rules[j].startTime || '00:00', 'HH:mm');
                this.holidayForm.rules[j].endTime = moment(this.holidayForm.rules[j].endTime || '00:00', 'HH:mm');
              }
            }
            this.foldtwohold();
          }
        }
      } catch (err) {
        console.log('err---', err);
        this.$message.error((err && err.msg) || '计费规则查询失败');
      } finally {
        this.initloading = false;
      }
    } else {
      // 新增
      this.reset(false);
      console.log('this.parkId', this.parkId);
      this.basicForm.parkId = this.parkId;
    }
  }

  // 判断是展开还是收起
  foldtwo() {
    if (
      this.normalForm.freeTimes != 0 ||
      this.normalForm.freeCounts != 0 ||
      this.normalForm.isUseCompleteUnit != '0' ||
      this.normalForm.isReBillingOverTwentyFour != '0' ||
      this.normalForm.overNightFee != 0 ||
      this.normalForm.oneOrMoreOverNightFee != '0' ||
      this.normalForm.limitMode != '0' ||
      this.normalForm.topMoney != 0
    ) {
      console.log(111);
      this.normalForm.moreflag = true;
    } else {
      this.normalForm.moreflag = false;
    }
    if (
      this.normalForm.isJustUseStartRule != '0' ||
      this.normalForm.onceTopMoney != 0 ||
      this.normalForm.isLimitSeparate != '0'
    ) {
      this.normalForm.getmoreflag = true;
    } else {
      this.normalForm.getmoreflag = false;
    }
  }
  foldtwohold() {
    if (
      this.holidayForm.freeTimes != 0 ||
      this.holidayForm.freeCounts != 0 ||
      this.holidayForm.isUseCompleteUnit != '0' ||
      this.holidayForm.isReBillingOverTwentyFour != '0' ||
      this.holidayForm.overNightFee != 0 ||
      this.holidayForm.oneOrMoreOverNightFee != '0' ||
      this.holidayForm.limitMode != '0' ||
      this.holidayForm.topMoney != 0
    ) {
      console.log(111);
      this.holidayForm.moreflag = true;
    } else {
      this.holidayForm.moreflag = false;
    }
    if (
      this.holidayForm.isJustUseStartRule != '0' ||
      this.holidayForm.onceTopMoney != 0 ||
      this.holidayForm.isLimitSeparate != '0'
    ) {
      this.holidayForm.getmoreflag = true;
    } else {
      this.holidayForm.getmoreflag = false;
    }
  }
  // 上传图片
  onUploadComplete(fileUrls: any[]) {
    // 新增和删除都会执行一次，在change后触发
    this.basicForm.images = fileUrls;
    console.log('文件列表', this.basicForm.images);
  }
  async onFileChange(fileList: any[]) {
    // 图片内容变化即执行，上传过程执行多次
    this.imagesListData = fileList;
    console.log('文件改变时', fileList);
  }
  //重置图片
  resetImage() {
    this.$nextTick(() => {
      this.imagesListData = [];
      this.basicForm.images = [];
      (this.$refs.imgUpload as Vue).resetFileList();
    });
  }
  handleNewChange(value) {
    console.log(value, '===== wo jiu kankan ');
    if (value === '4') {
      this.normalForm = {
        id: '',
        freeTime: 0, // 免费分钟
        includedFreeTime: '0', // 计费是否包含免费分钟(分钟)
        topMoneyOfTwentyFour: 0, // 24小时限额（0为不限额）
        freeTimes: 0, // 免收时长
        freeCounts: 0, // 自然日内免收时长享受次数
        isUseCompleteUnit: '0', // 不足计费单位默认补足
        isReBillingOverTwentyFour: '0', // 超24小时重新执行【起步时段】规则
        overNightFee: 0, // 跨0点收取过夜费
        oneOrMoreOverNightFee: '0', // 同一笔订单，多日跨0点只收一次过夜费
        limitMode: '0', // 请选择限额模式(不限首次)
        limitTime: '0', //请填写自定义时长
        topMoney: '0', // 最多收费金额
        isPremiumRateSwitch: '0', //打开阶梯费率
        isPremiumFenSwitch: '0', //打开分段计费
        billingOnFreeTimes: [],
        limitMoneyOfDefines: [
          {
            limitTime: '0',
            money: '0'
          }
        ],
        startChargeTime: 0,
        startChargeMoney: 0,
        cycleChargeTime: 0,
        cycleChargeMoney: 0,
        cycleChargeRateTime: 0,
        cycleChargeRateMoney: 0,
        isJustUseStartRule: '0',
        isLimitSeparate: '0',
        onceTopMoney: 0,
        rules: [
          {
            startTime: moment('00:00', 'HH:mm'),
            endTime: moment('00:00', 'HH:mm'),
            freeTime: 0,
            includedFreeTime: '0',
            topMoneyOfSection: 0,
            isPremiumRateSwitch: '0',
            startChargeTime: 0,
            startChargeMoney: 0,
            cycleChargeTime: 0,
            cycleChargeMoney: 0,
            cycleChargeRateTime: 0,
            cycleChargeRateMoney: 0,
            billingOnFreeTimes: []
          },
          {
            startTime: moment('00:00', 'HH:mm'),
            endTime: moment('00:00', 'HH:mm'),
            freeTime: 0,
            includedFreeTime: '0',
            topMoneyOfSection: 0,
            isPremiumRateSwitch: '0',
            startChargeTime: 0,
            startChargeMoney: 0,
            cycleChargeTime: 0,
            cycleChargeMoney: 0,
            cycleChargeRateTime: 0,
            cycleChargeRateMoney: 0,
            billingOnFreeTimes: []
          }
        ]
      };
    }
  }
  //停车名称变化
  onChangeParking() {
    this.resetImage();
  }
  getRuleServiceName(billingWay: string) {
    let serviceName = '';
    if (billingWay === '0') {
      serviceName = 'ChargeByTime';
    } else if (billingWay === '1') {
      serviceName = 'ChargeOnSeparate';
    } else if (billingWay === '2') {
      serviceName = 'ChargeOnShareTime';
    } else if (billingWay === '5') {
      serviceName = 'NewChargeOnTimes';
    } else if (billingWay === '4') {
      serviceName = 'TiYuJuChargeOnTimes';
    } else {
      serviceName = 'ChargeOnTimes';
    }
    return serviceName;
  }

  // 重置
  reset(boor: boolean = false, datePattern = '0', parkId = '') {
    this.imagesListData = [];
    this.basicForm.parkId = parkId || (boor && null);
    this.basicForm.feeName = '';
    this.basicForm.datePattern = datePattern;
    const billingWay = this.basicForm.billingWay;
    this.basicForm.billingWay = '0';
    this.basicForm.ruleCode = '';
    this.basicForm.remarks = '';
    this.resetImage();
    console.log(billingWay);
    if (billingWay === '0') {
      this.byTimeMainForm = {
        id: '',
        topMoney: '',
        includedFreeTime: '0',
        isReBillingOverTwentyFour: '0',
        afterFreeTime: 0,
        isContinueTwentyFour: '0',
        limitMode: '0',
        freeTime: 30,
        startChargeTime: 60,
        startChargeMoney: 1,
        cycleChargeTime: 60,
        cycleChargeMoney: 1,
        topMoneyOfTwentyFour: 0,
        isUseCompleteUnit: '0',
        limitMoneyOfDefines: [
          {
            limitTime: 0,
            money: 0
          }
        ],
        overNightFee: 0,
        oneOrMoreOverNightFee: '0'
      };
      this.byTimeBackUpForm = {
        id: '',
        topMoney: '',
        includedFreeTime: '0',
        isReBillingOverTwentyFour: '0',
        afterFreeTime: 0,
        isContinueTwentyFour: '0',
        limitMode: '0',
        freeTime: 30,
        startChargeTime: 60,
        startChargeMoney: 1,
        cycleChargeTime: 60,
        cycleChargeMoney: 1,
        topMoneyOfTwentyFour: 0,
        isUseCompleteUnit: '0',
        limitMoneyOfDefines: [
          {
            limitTime: 0,
            money: 0
          }
        ],
        overNightFee: 0,
        oneOrMoreOverNightFee: '0'
      };
    } else if (billingWay === '1') {
      const onSeparateFormArrDefault = [
        {
          startTime: '',
          endTime: '',
          startChargeTime: 60,
          startChargeMoney: 1,
          freeTime: 30,
          topMoneyOfSection: 0,
          cycleChargeTime: 60,
          cycleChargeMoney: 1
        } as IOnSeparateFormArr
      ];
      this.onSeparateForm = onSeparateFormDefault;
      console.log('onSeparateFormDefault', onSeparateFormDefault);
      console.log('  this.onSeparateForm', this.onSeparateForm);
      this.onSeparateFormArr = onSeparateFormArrDefault;
      this.onSeparateBackUpForm = cloneDeep(onSeparateFormDefault);
      this.onSeparateBackUpFormArr = cloneDeep(onSeparateFormArrDefault);
      console.log('this.onSeparateFormArr', this.onSeparateFormArr);
    } else if (billingWay === '2') {
      console.log('这里执行到了02', billingWay);

      const onShareTimeFormDefault = {
        freeTime: 30,
        includedFreeTime: '0',
        isContinueTwentyFour: '0',
        afterFreeTime: 0,
        limitMode: '0',
        topMoney: '0',
        topMoneyOfTwentyFour: 0,
        hour: 0,
        minutes: 0,
        cycleMoney: 0,
        id: '',
        limitMoneyOfDefines: [
          {
            limitTime: 0,
            money: 0
          }
        ],
        overNightFee: 0,
        oneOrMoreOverNightFee: '0'
      };
      this.onShareTimeForm = onShareTimeFormDefault;
      this.onShareTimeFormArr = [{ hour: '', minutes: 0, money: 0 }];
      this.onShareTimeBackForm = cloneDeep(onShareTimeFormDefault);
      this.onShareTimeBackFormArr = [{ hour: '', minutes: 0, money: 0 }];
    } else if (billingWay === '4' || billingWay === '5') {
      this.normalForm = {
        id: '',
        freeTime: 0, // 免费分钟
        includedFreeTime: '0', // 计费是否包含免费分钟(分钟)
        topMoneyOfTwentyFour: 0, // 24小时限额（0为不限额）
        freeTimes: 0, // 免收时长
        freeCounts: 0, // 自然日内免收时长享受次数
        isUseCompleteUnit: '0', // 不足计费单位默认补足
        isReBillingOverTwentyFour: '0', // 超24小时重新执行【起步时段】规则
        overNightFee: 0, // 跨0点收取过夜费
        oneOrMoreOverNightFee: '0', // 同一笔订单，多日跨0点只收一次过夜费
        limitMode: '0', // 请选择限额模式(不限首次)
        limitTime: '0', //请填写自定义时长
        topMoney: '0', // 最多收费金额
        isPremiumRateSwitch: '0', //打开阶梯费率
        isPremiumFenSwitch: '0', //打开分段计费
        billingOnFreeTimes: [],
        limitMoneyOfDefines: [
          {
            limitTime: '0',
            money: '0'
          }
        ],
        startChargeTime: 0,
        startChargeMoney: 0,
        cycleChargeTime: 0,
        cycleChargeMoney: 0,
        cycleChargeRateTime: 0,
        cycleChargeRateMoney: 0,
        isJustUseStartRule: '0',
        isLimitSeparate: '0',
        onceTopMoney: 0,
        rules: [
          {
            startTime: moment('00:00', 'HH:mm'),
            endTime: moment('00:00', 'HH:mm'),
            freeTime: 0,
            includedFreeTime: '0',
            topMoneyOfSection: 0,
            isPremiumRateSwitch: '0',
            startChargeTime: 0,
            startChargeMoney: 0,
            cycleChargeTime: 0,
            cycleChargeMoney: 0,
            cycleChargeRateTime: 0,
            cycleChargeRateMoney: 0,
            billingOnFreeTimes: []
          },
          {
            startTime: moment('00:00', 'HH:mm'),
            endTime: moment('00:00', 'HH:mm'),
            freeTime: 0,
            includedFreeTime: '0',
            topMoneyOfSection: 0,
            isPremiumRateSwitch: '0',
            startChargeTime: 0,
            startChargeMoney: 0,
            cycleChargeTime: 0,
            cycleChargeMoney: 0,
            cycleChargeRateTime: 0,
            cycleChargeRateMoney: 0,
            billingOnFreeTimes: []
          }
        ]
      };
    } else {
      const onTimesFormDefault = {
        id: '',
        includedFreeTime: '0',
        afterFreeTime: 0,
        freeTime: 30,
        startHour: 0,
        startMinutes: 0,
        endHour: 24,
        endMinutes: 0,
        moneyOnCycle: 5,
        topCount: 0,
        limitMode: '0',
        topMoney: '0',
        limitMoneyOfDefines: [
          {
            limitTime: 0,
            money: 0
          }
        ],
        overNightFee: 0,
        oneOrMoreOverNightFee: '0'
      };
      this.onTimesForm = onTimesFormDefault;
      this.onTimesBackUpForm = cloneDeep(onTimesFormDefault);
    }
  }

  // 提交保存监听处理
  async save(e: any) {
    // debugger
    if (!this.checkBasicForm()) {
      return false;
    }

    const billingWay = this.basicForm.billingWay;
    const datePattern = this.basicForm.datePattern;

    let form;
    if (billingWay === '0' && this.checkByTimeForm(datePattern)) {
      console.log(3);

      form = this.getFormBillingWay0(datePattern);
    } else if (billingWay === '1' && this.checkOnSeparateFormAll(datePattern)) {
      console.log(4);

      form = this.getFormBillingWay1(datePattern);
    } else if (billingWay === '2' && this.checkTimeSharing()) {
      console.log(5);

      form = this.getFormBillingWay2(datePattern);
    } else if (billingWay === '3' && this.checkOnTimesFormAll(datePattern)) {
      console.log(6);

      form = this.getFormBillingWay3(datePattern);
    } else if (billingWay === '4' && this.checkOnTimesFormAll(datePattern)) {
      console.log(444);
      form = this.getFormBillingWay4(datePattern);
      console.log(form, '99999----------->>>>');
      if (form.normalForm.freeCounts !== 0) {
        if (form.normalForm.freeTimes == 0) {
          return this.$message.warning('免收时长不能为0');
        }
      }
      if (this.basicForm.datePattern === '0') {
        // 常规
        if (form.normalForm.isPremiumFenSwitch == '0') {
          if (form.normalForm.isPremiumRateSwitch == '1' && form.normalForm.billingOnFreeTimes.length < 1) {
            return this.$message.warning('非法数据');
          }
          if (form.normalForm.isPremiumRateSwitch == '0') {
            if (form.normalForm.startChargeTime == 0) {
              return this.$message.warning('起始时间不能为0');
            } else if (form.normalForm.cycleChargeTime == 0) {
              return this.$message.warning('循环时间不能为0');
            }
          } else {
            if (form.normalForm.cycleChargeRateTime == 0) {
              return this.$message.warning('循环时间不能为0');
            }
          }
        } else {
          console.log(888);
          // 分段
          let a = 0;
          for (let i = 0; i < form.normalForm.rules.length; i++) {
            if (
              form.normalForm.rules[i].isPremiumRateSwitch == '1' &&
              form.normalForm.rules[i].billingOnFreeTimes.length < 1
            ) {
              return this.$message.warning('非法数据');
            }
            a =
              a +
              moment(`2020-10-10 ${form.normalForm.rules[i].endTime}:00`).diff(
                moment(`2020-10-10 ${form.normalForm.rules[i].startTime}:00`),
                'hours'
              );
            if (form.normalForm.rules[i].isPremiumRateSwitch == '0') {
              if (form.normalForm.rules[i].startChargeTime == 0) {
                return this.$message.warning(`第${i + 1}段起始时间不能为0`);
              } else if (form.normalForm.rules[i].cycleChargeTime == 0) {
                return this.$message.warning(`第${i + 1}段循环时间不能为0`);
              }
            } else {
              if (form.normalForm.rules[i].cycleChargeRateTime == 0) {
                return this.$message.warning(`第${i + 1}段循环时间不能为0`);
              }
            }
          }
          if (a === 0 || a === 24) {
            console.log('guo le --->');
          } else {
            return this.$message.warning('非法数据');
          }
        }
      } else {
        // 节假日
        if (form.holidayForm.isPremiumFenSwitch == '0') {
          if (form.holidayForm.isPremiumRateSwitch == '1' && form.holidayForm.billingOnFreeTimes.length < 1) {
            return this.$message.warning('非法数据');
          }
          if (form.holidayForm.isPremiumRateSwitch == '0') {
            if (form.holidayForm.startChargeTime == 0) {
              return this.$message.warning('起始时间不能为0');
            } else if (form.holidayForm.cycleChargeTime == 0) {
              return this.$message.warning('循环时间不能为0');
            }
          } else {
            if (form.holidayForm.cycleChargeRateTime == 0) {
              return this.$message.warning('循环时间不能为0');
            }
          }
        } else {
          console.log(888);
          // 分段
          let a = 0;
          for (let i = 0; i < form.holidayForm.rules.length; i++) {
            if (
              form.holidayForm.rules[i].isPremiumRateSwitch == '1' &&
              form.holidayForm.rules[i].billingOnFreeTimes.length < 1
            ) {
              return this.$message.warning('非法数据');
            }
            a =
              a +
              moment(`2020-10-10 ${form.holidayForm.rules[i].endTime}:00`).diff(
                moment(`2020-10-10 ${form.holidayForm.rules[i].startTime}:00`),
                'hours'
              );
            if (form.holidayForm.rules[i].isPremiumRateSwitch == '0') {
              if (form.holidayForm.rules[i].startChargeTime == 0) {
                return this.$message.warning(`第${i + 1}段起始时间不能为0`);
              } else if (form.holidayForm.rules[i].cycleChargeTime == 0) {
                return this.$message.warning(`第${i + 1}段循环时间不能为0`);
              }
            } else {
              if (form.holidayForm.rules[i].cycleChargeRateTime == 0) {
                return this.$message.warning(`第${i + 1}段循环时间不能为0`);
              }
            }
          }
          if (a === 0 || a === 24) {
            console.log('guo le --->');
          } else {
            return this.$message.warning('非法数据');
          }
        }
        // 工作日
        if (form.normalForm.isPremiumFenSwitch == '0') {
          if (form.normalForm.isPremiumRateSwitch == '1' && form.normalForm.billingOnFreeTimes.length < 1) {
            return this.$message.warning('非法数据');
          }
          if (form.normalForm.isPremiumRateSwitch == '0') {
            if (form.normalForm.startChargeTime == 0) {
              return this.$message.warning('起始时间不能为0');
            } else if (form.normalForm.cycleChargeTime == 0) {
              return this.$message.warning('循环时间不能为0');
            }
          } else {
            if (form.normalForm.cycleChargeRateTime == 0) {
              return this.$message.warning('循环时间不能为0');
            }
          }
        } else {
          console.log(888);
          // 分段
          let a = 0;
          for (let i = 0; i < form.normalForm.rules.length; i++) {
            if (
              form.normalForm.rules[i].isPremiumRateSwitch == '1' &&
              form.normalForm.rules[i].billingOnFreeTimes.length < 1
            ) {
              return this.$message.warning('非法数据');
            }
            a =
              a +
              moment(`2020-10-10 ${form.normalForm.rules[i].endTime}:00`).diff(
                moment(`2020-10-10 ${form.normalForm.rules[i].startTime}:00`),
                'hours'
              );
            if (form.normalForm.rules[i].isPremiumRateSwitch == '0') {
              if (form.normalForm.rules[i].startChargeTime == 0) {
                return this.$message.warning(`第${i + 1}段起始时间不能为0`);
              } else if (form.normalForm.rules[i].cycleChargeTime == 0) {
                return this.$message.warning(`第${i + 1}段循环时间不能为0`);
              }
            } else {
              if (form.normalForm.rules[i].cycleChargeRateTime == 0) {
                return this.$message.warning(`第${i + 1}段循环时间不能为0`);
              }
            }
          }
          if (a === 0 || a === 24) {
            console.log('guo le --->');
          } else {
            return this.$message.warning('非法数据');
          }
        }
      }
    } else if (billingWay === '5' && this.checkOnTimesFormAll(datePattern)) {
      console.log(444);
      form = this.getFormBillingWay4(datePattern);
      console.log(form, '99999----------->>>>');
      if (form.normalForm.freeCounts !== 0) {
        if (form.normalForm.freeTimes == 0) {
          return this.$message.warning('免收时长不能为0');
        }
      }
      if (this.basicForm.datePattern === '0') {
        // 常规
        if (form.normalForm.isPremiumFenSwitch == '0') {
          if (form.normalForm.isPremiumRateSwitch == '1' && form.normalForm.billingOnFreeTimes.length < 1) {
            return this.$message.warning('非法数据');
          }
          if (form.normalForm.isPremiumRateSwitch == '0') {
            if (form.normalForm.startChargeTime == 0) {
              return this.$message.warning('起始时间不能为0');
            } else if (form.normalForm.cycleChargeTime == 0) {
              return this.$message.warning('循环时间不能为0');
            }
          } else {
            if (form.normalForm.cycleChargeRateTime == 0) {
              return this.$message.warning('循环时间不能为0');
            }
          }
        } else {
          console.log(888);
          // 分段
          let a = 0;
          for (let i = 0; i < form.normalForm.rules.length; i++) {
            if (
              form.normalForm.rules[i].isPremiumRateSwitch == '1' &&
              form.normalForm.rules[i].billingOnFreeTimes.length < 1
            ) {
              return this.$message.warning('非法数据');
            }
            a =
              a +
              moment(`2020-10-10 ${form.normalForm.rules[i].endTime}:00`).diff(
                moment(`2020-10-10 ${form.normalForm.rules[i].startTime}:00`),
                'hours'
              );
            if (form.normalForm.rules[i].isPremiumRateSwitch == '0') {
              if (form.normalForm.rules[i].startChargeTime == 0) {
                return this.$message.warning(`第${i + 1}段起始时间不能为0`);
              } else if (form.normalForm.rules[i].cycleChargeTime == 0) {
                return this.$message.warning(`第${i + 1}段循环时间不能为0`);
              }
            } else {
              if (form.normalForm.rules[i].cycleChargeRateTime == 0) {
                return this.$message.warning(`第${i + 1}段循环时间不能为0`);
              }
            }
          }
          if (a === 0 || a === 24) {
            console.log('guo le --->');
          } else {
            return this.$message.warning('非法数据');
          }
        }
      } else {
        // 节假日
        if (form.holidayForm.isPremiumFenSwitch == '0') {
          if (form.holidayForm.isPremiumRateSwitch == '1' && form.holidayForm.billingOnFreeTimes.length < 1) {
            return this.$message.warning('非法数据');
          }
          if (form.holidayForm.isPremiumRateSwitch == '0') {
            if (form.holidayForm.startChargeTime == 0) {
              return this.$message.warning('起始时间不能为0');
            } else if (form.holidayForm.cycleChargeTime == 0) {
              return this.$message.warning('循环时间不能为0');
            }
          } else {
            if (form.holidayForm.cycleChargeRateTime == 0) {
              return this.$message.warning('循环时间不能为0');
            }
          }
        } else {
          console.log(888);
          // 分段
          let a = 0;
          for (let i = 0; i < form.holidayForm.rules.length; i++) {
            if (
              form.holidayForm.rules[i].isPremiumRateSwitch == '1' &&
              form.holidayForm.rules[i].billingOnFreeTimes.length < 1
            ) {
              return this.$message.warning('非法数据');
            }
            a =
              a +
              moment(`2020-10-10 ${form.holidayForm.rules[i].endTime}:00`).diff(
                moment(`2020-10-10 ${form.holidayForm.rules[i].startTime}:00`),
                'hours'
              );
            if (form.holidayForm.rules[i].isPremiumRateSwitch == '0') {
              if (form.holidayForm.rules[i].startChargeTime == 0) {
                return this.$message.warning(`第${i + 1}段起始时间不能为0`);
              } else if (form.holidayForm.rules[i].cycleChargeTime == 0) {
                return this.$message.warning(`第${i + 1}段循环时间不能为0`);
              }
            } else {
              if (form.holidayForm.rules[i].cycleChargeRateTime == 0) {
                return this.$message.warning(`第${i + 1}段循环时间不能为0`);
              }
            }
          }
          if (a === 0 || a === 24) {
            console.log('guo le --->');
          } else {
            return this.$message.warning('非法数据');
          }
        }
        // 工作日
        if (form.normalForm.isPremiumFenSwitch == '0') {
          if (form.normalForm.isPremiumRateSwitch == '1' && form.normalForm.billingOnFreeTimes.length < 1) {
            return this.$message.warning('非法数据');
          }
          if (form.normalForm.isPremiumRateSwitch == '0') {
            if (form.normalForm.startChargeTime == 0) {
              return this.$message.warning('起始时间不能为0');
            } else if (form.normalForm.cycleChargeTime == 0) {
              return this.$message.warning('循环时间不能为0');
            }
          } else {
            if (form.normalForm.cycleChargeRateTime == 0) {
              return this.$message.warning('循环时间不能为0');
            }
          }
        } else {
          console.log(888);
          // 分段
          let a = 0;
          for (let i = 0; i < form.normalForm.rules.length; i++) {
            if (
              form.normalForm.rules[i].isPremiumRateSwitch == '1' &&
              form.normalForm.rules[i].billingOnFreeTimes.length < 1
            ) {
              return this.$message.warning('非法数据');
            }
            a =
              a +
              moment(`2020-10-10 ${form.normalForm.rules[i].endTime}:00`).diff(
                moment(`2020-10-10 ${form.normalForm.rules[i].startTime}:00`),
                'hours'
              );
            if (form.normalForm.rules[i].isPremiumRateSwitch == '0') {
              if (form.normalForm.rules[i].startChargeTime == 0) {
                return this.$message.warning(`第${i + 1}段起始时间不能为0`);
              } else if (form.normalForm.rules[i].cycleChargeTime == 0) {
                return this.$message.warning(`第${i + 1}段循环时间不能为0`);
              }
            } else {
              if (form.normalForm.rules[i].cycleChargeRateTime == 0) {
                return this.$message.warning(`第${i + 1}段循环时间不能为0`);
              }
            }
          }
          if (a === 0 || a === 24) {
            console.log('guo le --->');
          } else {
            return this.$message.warning('非法数据');
          }
        }
      }
    }
    // 这期只有按时计费才显示计费规则编号
    if (billingWay !== '0') {
      delete this.basicForm.ruleCode;
    }
    if (form) {
      form.serviceName = this.getRuleServiceName(billingWay);
      try {
        if (this.spining) return;
        this.spining = true;
        let { msg, data } = await addRule(form);
        // 这样写代码我也是第一次遇到 后端成功失败都塞到success返回了
        if (data === '您当前填写的计费规则编号已存在，每个车场下的计费规则编号必须唯一哦！') {
          this.$message.error(data);
          return;
        }
        if (data === '分段计费时间段应闭合') {
          return this.$message.error(data || '保存失败');
        } else if (data === '阶梯费率不能为空') {
          return this.$message.error(data || '保存失败');
        } else {
          this.$message.success(msg || '保存成功');
          this.reset();
          this.$emit('complete');
          this.$emit('returnBack');
        }

        //this.$router.go(-1)
      } catch (err) {
        console.log('err---', err);
        this.$message.error((err && err.msg) || '保存失败');
      } finally {
        this.spining = false;
      }
    }
  }

  checkBasicForm() {
    const parkId = this.basicForm.parkId;
    const feeName = this.basicForm.feeName;
    console.log('parkId', parkId);
    console.log('feeName', feeName);

    if (!parkId) {
      this.$message.error('请选择车场');
      return false;
    }
    if (!feeName) {
      this.$message.error('请输入收费规则名称');
      return false;
    }
    return true;
  }

  getFormBillingWay0(datePattern: string) {
    let finalForm = Object.assign(this.basicForm, this.byTimeMainForm);
    // 按时计费
    const byTimeBackUpForm: Record<string, any> = {};
    if (datePattern === '1' || datePattern === '2') {
      Object.keys(this.byTimeBackUpForm).forEach(item => {
        byTimeBackUpForm[item + '1'] = this.byTimeBackUpForm[item as keyof IByTimeMainForm];
      });
      finalForm = { ...finalForm, ...byTimeBackUpForm };
    }
    return finalForm;
  }
  getFormBillingWay1(datePattern: string) {
    const finalForm: any = {};
    finalForm.onSeparateForm = this.onSeparateForm;
    finalForm.onSeparateFormArr = this.onSeparateFormArr;
    finalForm.basicForm = this.basicForm;
    if (datePattern === '1' || datePattern === '2') {
      finalForm.onSeparateBackUpForm = this.onSeparateBackUpForm;
      finalForm.onSeparateBackUpFormArr = this.onSeparateBackUpFormArr;
    }
    return finalForm;
  }
  handleOnShareTimeForm(finalForm: any, form: any, formArr: any, formName: any, formArrName: any) {
    const hour = form.hour;
    const minutes = form.minutes;
    form.cycleTime = hour * 60 + minutes;
    finalForm[formName] = form;

    finalForm[formArrName] = formArr.map((obj: IOnShareTimeFormArr) => {
      return {
        time: Number(obj.hour) * 60 + obj.minutes,
        money: obj.money
      };
    });
    return finalForm;
  }
  getFormBillingWay2(datePattern: string) {
    let finalForm: any = {};
    finalForm.basicForm = this.basicForm;

    finalForm = this.handleOnShareTimeForm(
      finalForm,
      this.onShareTimeForm,
      this.onShareTimeFormArr,
      'onShareTimeForm',
      'onShareTimeFormArr'
    );
    if (datePattern === '1' || datePattern === '2') {
      finalForm = this.handleOnShareTimeForm(
        finalForm,
        this.onShareTimeBackForm,
        this.onShareTimeBackFormArr,
        'onShareTimeBackForm',
        'onShareTimeBackFormArr'
      );
    }
    console.log(finalForm);
    return finalForm;
  }
  getFormBillingWay3(datePattern: string) {
    const finalForm: any = {};
    finalForm.basicForm = this.basicForm;
    const onTimesForm = this.onTimesForm;
    finalForm.onTimesForm = {
      cycleStartTime: onTimesForm.startHour * 60 + onTimesForm.startMinutes,
      cycleEndTime: onTimesForm.endHour * 60 + onTimesForm.endMinutes,
      ...onTimesForm
    };
    if (datePattern === '1' || datePattern === '2') {
      const onTimesBackUpForm = this.onTimesBackUpForm;
      finalForm.onTimesBackUpForm = {
        cycleStartTime: onTimesBackUpForm.startHour * 60 + onTimesBackUpForm.startMinutes,
        cycleEndTime: onTimesBackUpForm.endHour * 60 + onTimesBackUpForm.endMinutes,
        ...onTimesBackUpForm
      };
    }
    return finalForm;
  }
  // 新按时计费
  getFormBillingWay4(datePattern: string) {
    let finalForm: any = {};
    finalForm.basicForm = this.basicForm;
    finalForm.normalForm = this.normalForm;
    if (this.normalForm.rules.length > 0 && this.normalForm.isPremiumFenSwitch == '1') {
      for (let i = 0; i < this.normalForm.rules.length; i++) {
        this.normalForm.rules[i].isPremiumRateSwitch = this.normalForm.rules[i].isPremiumRateSwitch + '';
        this.normalForm.rules[i].includedFreeTime = this.normalForm.rules[i].includedFreeTime + '';
        if (this.normalForm.rules[i].startTime.length === 5) {
          console.log(this.normalForm.rules[i].startTime);
        } else {
          if (this.normalForm.rules[i].startTime !== '') {
            this.normalForm.rules[i].startTime = moment(this.normalForm.rules[i].startTime).format('HH:mm');
          } else {
            this.normalForm.rules[i].startTime = '';
          }
        }
        if (this.normalForm.rules[i].endTime.length === 5) {
          console.log(this.normalForm.rules[i].endTime);
        } else {
          if (this.normalForm.rules[i].endTime !== '') {
            this.normalForm.rules[i].endTime = moment(this.normalForm.rules[i].endTime).format('HH:mm');
          } else {
            this.normalForm.rules[i].endTime = '';
          }
        }
        // 时间的校验
      }
    }
    console.log(datePattern, 'le-----------');
    if (datePattern === '1' || datePattern === '2') {
      finalForm.holidayForm = this.holidayForm;
      finalForm.holidayForm.datePattern = '2';
      if (this.holidayForm.rules.length > 0 && this.holidayForm.isPremiumFenSwitch == '1') {
        for (let i = 0; i < this.holidayForm.rules.length; i++) {
          this.holidayForm.rules[i].isPremiumRateSwitch = this.holidayForm.rules[i].isPremiumRateSwitch + '';
          if (this.holidayForm.rules[i].startTime.length === 5) {
            console.log(this.holidayForm.rules[i].startTime);
          } else {
            if (this.holidayForm.rules[i].startTime !== '') {
              this.holidayForm.rules[i].startTime = moment(this.holidayForm.rules[i].startTime).format('HH:mm');
            } else {
              this.holidayForm.rules[i].startTime = '';
            }
          }
          if (this.holidayForm.rules[i].endTime.length === 5) {
            console.log(this.holidayForm.rules[i].endTime);
          } else {
            if (this.holidayForm.rules[i].endTime !== '') {
              this.holidayForm.rules[i].endTime = moment(this.holidayForm.rules[i].endTime).format('HH:mm');
            } else {
              this.holidayForm.rules[i].endTime = '';
            }
          }
        }
      }
    }
    return finalForm;
  }

  // 新计费规则校验
  // getTimerules(values) {
  //   let a = 0
  //   for (let i = 0; i < values.rules.length; i++) {
  //     a =
  //       a +
  //       moment(`2020-10-10 ${values.rules[i].endTime}:00`).diff(
  //         moment(`2020-10-10 ${values.rules[i].startTime}:00`),
  //         'hours',
  //       )
  //   }
  //   console.log(a, '=====我拿到了-------》》》')
  //   if (a === 0 || a === 24) {
  //     console.log('guo le --->')
  //     finalForm.flag = true
  //   } else {
  //     console.log('bu guo -->')
  //     finalForm.flag = false
  //     return this.$message.warning('非法数据')
  //   }
  // }
  checkTimeSharingFun(array) {
    console.log('this.array', this.array);
    const length = array.length;
    const lastFirstItem = array[length - 1];
    const lastFirstTotalMinutes = Number(lastFirstItem.hour) * 60 + lastFirstItem.minutes;
    if (lastFirstTotalMinutes <= 0) {
      this.$message.error('时长不能为空');
      return false;
    }
    if (length > 1) {
      const lastSeconodItem = array[length - 2];
      const lastSecondTotalMinutes = Number(lastSeconodItem.hour) * 60 + lastSeconodItem.minutes;

      if (lastSecondTotalMinutes >= lastFirstTotalMinutes) {
        this.$message.error('本段时长不能小于上一段');
        return false;
      }
    }
    return true;
  }
  // 分时计费校验
  checkTimeSharing() {
    if (!this.checkTimeSharingFun(this.onShareTimeFormArr)) {
      return false;
    }
    // if (!this.checkTimeSharingFun(this.onShareTimeBackFormArr)) {
    //   return false
    // }
    return true;
  }
  // 按时计费校验
  checkByTimeForm(datePattern: string) {
    const title = this.getDatePatternTitle(datePattern);
    const startChargeTime = this.byTimeMainForm.startChargeTime;
    const cycleChargeTime = this.byTimeMainForm.cycleChargeTime;
    const isInteger = (24 * 60 - startChargeTime) % cycleChargeTime === 0;
    if (!isInteger) {
      this.$message.error((title ? title + '=>' : '') + '当前起步时段与循环时段无法组合为整24小时,请核实!');
      return false;
    }
    if (datePattern === '1' || datePattern === '2') {
      const titleBackUp = this.getDatePatternTitleBackUp(datePattern);
      const startChargeTime = this.byTimeBackUpForm.startChargeTime;
      const cycleChargeTime = this.byTimeBackUpForm.cycleChargeTime;
      const isInteger = (24 * 60 - startChargeTime) % cycleChargeTime === 0;
      if (!isInteger) {
        this.$message.error(titleBackUp + '=>当前起步时段与循环时段无法组合为整24小时,请核实!');
        return false;
      }
    }
    return true;
  }
  // 分段计费校验
  checkOnSeparateFormAll(datePattern: string) {
    const title = this.getDatePatternTitle(datePattern);
    if (!this.checkOnSeparateForm(title, this.onSeparateFormArr)) {
      return false;
    }

    if (datePattern === '1' || datePattern === '2') {
      const titleBackUp = this.getDatePatternTitleBackUp(datePattern);
      if (!this.checkOnSeparateForm(titleBackUp, this.onSeparateBackUpFormArr)) {
        return false;
      }
    }
    return true;
  }
  checkOnSeparateForm(title: string, onSeparateFormArr: IOnSeparateFormArr[]) {
    const length = onSeparateFormArr.length;
    const firstItem = onSeparateFormArr[0];
    const lastItem = onSeparateFormArr[length - 1];

    for (const item of onSeparateFormArr) {
      const startHour =
        typeof item.startTime === 'object' ? item.startTime._i.split(':')[0] : item.startTime.split(':')[0];
      const startMins =
        typeof item.startTime === 'object' ? item.startTime._i.split(':')[1] : item.startTime.split(':')[1];
      const endHour = typeof item.endTime === 'object' ? item.endTime._i.split(':')[0] : item.endTime.split(':')[0];
      const endMins = typeof item.endTime === 'object' ? item.endTime._i.split(':')[1] : item.endTime.split(':')[1];

      // let startHour = (form.startTime._i || form.startTime).split(':')[0]
      // let startMins = (form.startTime._i || form.startTime).split(':')[1]
      // let endHour = (form.endTime._i || form.endTime).split(':')[0]
      // let endMins = (form.endTime._i || form.endTime).split(':')[1]
      const isInteger =
        (endHour * 60 + endMins - (startHour * 60 + startMins) - item.startChargeTime) % item.cycleChargeTime === 0;
      if (!isInteger) {
        this.$message.error(title + '=>当前起步时段与循环时段无法组合为[起步时间-结束时间]的时间差,请核实!');
        return false;
      }
    }

    if (firstItem.startTime !== lastItem.endTime) {
      // moment(lastItem.endTime).diff(moment(firstItem.startTime)) === 0
      this.$message.error(title + '=>当前不是一个完整的分段计费周期,请核实');
      return false;
    }
    if (length === 1 && firstItem.startTime === firstItem.endTime) {
      this.$message.error(title + '=>本次分段的开始时间不能与结束时间相等或都为空');
      return false;
    }
    return true;
  }
  // 按次计费校验
  checkOnTimesFormAll(datePattern: string) {
    const title = this.getDatePatternTitle(datePattern);
    if (!this.checkOnTimesForm(title, this.onTimesForm)) {
      return false;
    }

    if (datePattern === '1' || datePattern === '2') {
      const titleBackUp = this.getDatePatternTitleBackUp(datePattern);
      if (!this.checkOnTimesForm(titleBackUp, this.onTimesBackUpForm)) {
        return false;
      }
    }
    return true;
  }
  checkOnTimesForm(title: string, onTimesForm: IOnTimesForm) {
    const startHour = this.onTimesForm.startHour;
    const startMinutes = this.onTimesForm.startMinutes;
    const endHour = this.onTimesForm.endHour;
    const endMinutes = this.onTimesForm.endMinutes;
    const isInteger = (endHour * 60 + endMinutes - (startHour * 60 + startMinutes)) % 60 === 0;

    if (!isInteger) {
      this.$message.error((title ? title + '=>' : '') + '当前周期时间无法在24小时内有效循环!');
      return false;
    }
    return true;
  }
  // 工作日节假日标题栏和提示文案判断逻辑
  getDatePatternTitle(datePattern: string) {
    return datePattern === '1' ? '工作日' : datePattern === '2' ? '节假日' : '';
  }
  getDatePatternTitleBackUp(datePattern: string) {
    return datePattern === '1' ? '节假日' : '工作日';
  }
  //返回
  goBack() {
    // this.reset();
    this.$emit('returnBack');
  }

  // 新按时计费
}
